export default __webpack_public_path__ + "static/media/example_ticket.aae5989f.png";